import { FC } from 'react'
import BackButton from '@organisms/BackButton'
import NextButton from '@organisms/NextButton'
import { ButtonsWrapper } from './styled'
import ChangeThemeButton from './ChangeThemeButton'

type Props = {
  prevRoute?: string | null
  nextRoute?: string | null
  onChangePage: () => Promise<void>
  isTestBlocked?: boolean
  onBlockedNavigation?: (pendingNavigation?: () => void) => void
  isPreviewMode?: boolean
}

const NavigationBlock: FC<Props> = ({
  prevRoute,
  nextRoute,
  onChangePage,
  isTestBlocked,
  onBlockedNavigation,
  isPreviewMode,
}) => {
  return (
    <ButtonsWrapper>
      <ChangeThemeButton
        ButtonComponent={(props) => (
          <BackButton {...props}>Предыдущий модуль</BackButton>
        )}
        newRoute={prevRoute}
        onChangePage={onChangePage}
        isTestBlocked={isTestBlocked}
        onBlockedNavigation={onBlockedNavigation}
        isPreviewMode={isPreviewMode}
        id="prev"
      />
      <ChangeThemeButton
        ButtonComponent={(props) => (
          <NextButton {...props}>Следующий модуль</NextButton>
        )}
        newRoute={nextRoute}
        onChangePage={onChangePage}
        isTestBlocked={isTestBlocked}
        onBlockedNavigation={onBlockedNavigation}
        isPreviewMode={isPreviewMode}
        id="next"
      />
    </ButtonsWrapper>
  )
}

export default NavigationBlock
